export const specieIconFromId = (id, species) => {

    //Si id est transmis comme Str
    const specieId = Number.parseInt(id);

    const specie = species.find((item) => { return item.id === specieId });

    if (specie === undefined || specie.icon === null) {
        return "";
    } else {
        return specie.icon;
    }
}
export const specieNameFromId = (id, species) => {

    //Si id est transmis comme Str
    const specieId = Number.parseInt(id);

    const specie = species.find((item) => { return item.id === specieId });

    if (specie === undefined || specie.label === null) {
        return "";
    } else {
        return specie.label;
    }
}
export const specieFromId = (id, species) => {
    const specieId = Number.parseInt(id);
    const specie = species.find((item) => { return item.id === specieId });
    return specie;
}
export const computeCost = (analyses, bilans) => {
    let totalCost = 0;
    analyses.forEach((category) => {
        category.analyses.forEach((item) => {
            if (!(item.checked === false || item.checked === undefined) && (item.locked === false || item.locked === undefined)) {
                totalCost = totalCost + Number.parseFloat(item.price);
            }
        })
        category.bilans.forEach((item) => {
            if (!(item.checked === false || item.checked === undefined) && (item.locked === false || item.locked === undefined)) {
                totalCost = totalCost + Number.parseFloat(item.price);
            }
        })
    })
    bilans.forEach((item) => {
        if (!(item.checked === false || item.checked === undefined)) {
            totalCost = totalCost + Number.parseFloat(item.price);
        }
    })
    return totalCost
}
//STATUT DES ANALYSES:
    //checked: selectionné directement pour la demande courante
    //locked: selectionné indirectement pour la demande courante
    //prescriptible: true or false (true if not mentionned)
    //already_ordered: déjà selectionné dans une demande précédente
export function setAnalysesStatus(idArray, setAnalyses, key, value) {

    idArray.forEach((id) => {
        setAnalyses((old) => old.map((category) => {
            return {
                ...category,
                analyses: category.analyses.map((analyse) => {
                    if (analyse.id === id) {
                        return ({
                            ...analyse,
                            [key]: value
                        });
                    } else {
                        return analyse;
                    }
                })
            }
        }))
    })
}
export function setFalseBilansStatus(idArray, setAnalyses, key, value) {

    idArray.forEach((id) => {
        setAnalyses((old) => old.map((category) => {
            return {
                ...category,
                bilans: category.bilans.map((bilan) => {
                    if (bilan.id === id) {
                        return ({
                            ...bilan,
                            [key]: value
                        });
                    } else {
                        return bilan;
                    }
                })
            }
        }))
    })
}
export function setBilansStatus(idArray, setBilans, key, value) {

    idArray.forEach((id) => {
        setBilans((old)=>old.map((bilan)=>{
            if(bilan.id===id){
                return {
                    ...bilan,
                    [key]: value
                }
            } else {
                return bilan
            }
        }))
    })
}
export const handleBilanSelectById = (id, bilans, setBilans, setAnalyses) => {
    setBilans(bilans.map((bilan) => {
        if (bilan.id === id && bilan.prescriptible!==false) {
            setAnalysesStatus(bilan.analyses, setAnalyses, "locked", !bilan.checked);
            setFalseBilansStatus(bilan.bilans, setAnalyses, "locked", !bilan.checked);
            return {
                ...bilan,
                checked: !bilan.checked
            }
        } else {
            return bilan;
        }
    }));
}
export const handleAnalyseSelectById = (id, isBilan = false,setAnalyses,analyses,collectAdditionalInfo = null) => {

    if (isBilan === true) {
        let analysesId;
        let lock;

        //check bilan
        setAnalyses(analyses.map((category) => {
            const tempAnalyse = category.bilans.map((bilan) => {
                if (bilan.id === id && bilan.prescriptible!==false) {
                    if (bilan.checked) {
                        lock = false;
                    } else {
                        collectAdditionalInfo && collectAdditionalInfo(category.code, id, true);
                        lock = true;
                    }
                    analysesId = bilan.analyses;
                    return { ...bilan, checked: !bilan.checked };
                } else {
                    return bilan;
                }
            })
            return { ...category, bilans: tempAnalyse }
        }
        ));
        setAnalysesStatus(analysesId, setAnalyses, "locked",lock);

    } else {
        setAnalyses(analyses.map((category) => {
            const tempAnalyse = category.analyses.map((analyse) => {
                if (analyse.id === id && analyse.prescriptible!==false) {
                    if (analyse.checked === false || analyse.checked === undefined) {
                        collectAdditionalInfo && collectAdditionalInfo(category.code, id, false, analyse.mnemonic);
                    }
                    return { ...analyse, checked: !analyse.checked, comments: undefined };
                } else {
                    return analyse;
                }
            })
            return { ...category, analyses: tempAnalyse }
        }))
    }
}
export const atLeastOneAnalyse = (analyses,bilans) => {
    //à modifier avec bilans et faut bilans
    let validation = false;
    analyses.forEach((category) => {
        category.analyses.forEach((item) => {
            if (item.checked) {
                validation = true;
            }
        })
        category.bilans.forEach((item) => {
            if (item.checked) {
                validation = true;
            }
        })
        bilans.forEach((item) => {
            if (item.checked) {
                validation = true;
            }
        })
    })
    return validation;
}
export const fillAnalyses = (analyses) => {
    let analysesId = [];
    analyses.forEach((category) => {
        category.analyses.forEach((item) => {
            if (!(item.checked === false || item.checked === undefined) && (item.locked === false || item.locked === undefined)) {
                analysesId.push(item.id);
            }
        })
    })
    return analysesId;
}

export const fillBilans = (analyses,bilans) => {
    let bilansId = [];
    analyses.forEach((category) => {
        category.bilans.forEach((item) => {
            if (!(item.checked === false || item.checked === undefined)) {
                bilansId.push(item.id);
            }
        })
    })
    bilans.forEach((item) => {
        if (!(item.checked === false || item.checked === undefined)) {
            bilansId.push(item.id);
        }
    })
    return bilansId;
}

export const fillCommentsAnalyses = (analyses) => {
    let comments = [];
    analyses.forEach((category) => {
        category.analyses.forEach((analyse) => {
            if (analyse.comments !== undefined) {
                comments = comments.concat(analyse.comments);
            }
        })
    })

    return comments;
}

export const fillCommentsBilans = (analyses) => {
    let comments = [];
    analyses.forEach((category) => {
        category.bilans.forEach((bilan) => {
            if (bilan.comments !== undefined) {
                comments = comments.concat(bilan.comments);
            }
        })
    })

    return comments;
}